let DOM;

if (__SERVER__) {
  const { JSDOM } = require('jsdom');

  DOM = (html) => {
    const dom = new JSDOM(html, { runScripts: 'dangerously' });

    return dom.window.document;
  };
} else {
  DOM = (html) => {
    const doc = document.createElement('html');

    doc.innerHTML = html;

    return doc;
  };
}

export default (html) => {
  const dom = DOM(html);
  const scripts = dom.getElementsByTagName('script');

  return Object.keys(scripts)
    .map((e) => scripts[e].text)
    .join('\n;\n');
};
